<mat-form-field
  *ngIf="!selectedSeller"
  class="tv-ns-white-search-medium flex-direction-row"
  floatLabel="never">
  <input
    (keyup)="searchCommercial($event)"
    [formControl]="searchFormControl"
    matInput
    [placeholder]="selectedSellerPlaceholder"
  >
  <button
    [ngClass]="searchFormControl.value ? 'tv-visible-clear-btn' : 'tv-invisible-clear-btn'"
    aria-label="Clear"
    class="tv-clear-input-icon-button"
    matSuffix>
    <mat-icon (click)="selectSeller()" class="mat-icon">close</mat-icon>
  </button>
  <mat-icon matPrefix class="mat-icon-search">search</mat-icon>
</mat-form-field>

<div *ngIf="sellerFiltered?.length" class="channel-group-select-dropdown">
  <div
    *ngFor="let seller of sellerFiltered"
    (click)="selectSeller(seller)"
    class="seller-group-select-option">
    {{ seller.nomUt }}
  </div>
</div>

<button *ngIf="selectedSeller"
        class="hour-select-button active-hour-select-button">
  <div class="layout-row">
    <mat-chip-set class="flex tv-container-screen-chip-list padding-left-10">
      <div>{{ selectedSellerPlaceholder }}</div>
    </mat-chip-set>
    <span
      class="hour-select-button hour-button-custom"
      (click)="selectSeller()"
      [ngClass]="'active-hour-select-button'">
                <span (click)="selectSeller()">
                  {{ selectedSeller.nomUt + ' - ' + selectedSeller.codUt }}
                </span>
              <mat-icon class="material-icons-outlined margin-left-10 clickable">close</mat-icon>
            </span>
  </div>
</button>


